import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "grey lighten-5 px-4 py-4" };
const _hoisted_2 = { class: "require-field-wrapper pb-4" };
const _hoisted_3 = { class: "d-flex align-center px-4 pt-2" };
const _hoisted_4 = { ref: "embed" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DialogHeader = _resolveComponent("DialogHeader");
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_v_text_field = _resolveComponent("v-text-field");
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_v_card = _resolveComponent("v-card");
    const _component_DialogFooter = _resolveComponent("DialogFooter");
    const _component_v_dialog = _resolveComponent("v-dialog");
    return (_openBlock(), _createBlock(_component_v_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.dialog) = $event)),
        "content-class": "responsive-dialog change-postcode-dialog"
    }, {
        activator: _withCtx(({ props }) => [
            _renderSlot(_ctx.$slots, "activator", _normalizeProps(_guardReactiveProps(props)))
        ]),
        default: _withCtx(() => [
            _createVNode(_component_v_card, {
                flat: "",
                tile: ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_DialogHeader, {
                        title: _ctx.$t(`${_ctx.lc}change_address_dialog_title`),
                        "on-cancel": _ctx.handleClickCancelChangePostcode
                    }, null, 8 /* PROPS */, ["title", "on-cancel"]),
                    _createCommentVNode(" 기존 주소 "),
                    _createVNode(_component_v_card, {
                        flat: "",
                        tile: "",
                        class: "grey lighten-4"
                    }, {
                        default: _withCtx(() => [
                            _createCommentVNode(" 변경 전 "),
                            _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-0" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.before_change')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_card_title, { class: "text-body-1 pt-2" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.computedDropAddressShorten), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_divider),
                            _createCommentVNode(" 주소 검색 "),
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createCommentVNode(" 변경 후 "),
                                    _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-0" }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.after_change')), 1 /* TEXT */),
                                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-red" }, "*", -1 /* CACHED */))
                                        ]),
                                        _: 1 /* STABLE */,
                                        __: [4]
                                    }),
                                    _createCommentVNode(" 주소 검색 input "),
                                    _createElementVNode("div", _hoisted_3, [
                                        _createVNode(_component_v_text_field, {
                                            modelValue: _ctx.computedCurrentDropAddress,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.computedCurrentDropAddress) = $event)),
                                            readonly: "",
                                            "hide-details": "",
                                            placeholder: _ctx.$t(`${_ctx.lc}search_postcode`),
                                            variant: "outlined",
                                            dense: "",
                                            class: "grow",
                                            "data-cy": "current-drop-address",
                                            onClick: _ctx.handleClickPostcode
                                        }, null, 8 /* PROPS */, ["modelValue", "placeholder", "onClick"]),
                                        _createVNode(_component_v_btn, {
                                            large: "",
                                            variant: "outlined",
                                            height: "40",
                                            "data-cy": "search-postcode-button",
                                            class: "ml-2 btn-outlined-basic",
                                            onClick: _ctx.handleClickPostcode
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_icon, {
                                                    small: "",
                                                    class: "pr-1"
                                                }, {
                                                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                        _createTextVNode(" mdi-magnify ")
                                                    ])),
                                                    _: 1 /* STABLE */,
                                                    __: [5]
                                                }),
                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.lc}search_postcode`)), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"])
                                    ]),
                                    _createCommentVNode(" 상세 주소 "),
                                    _createVNode(_component_v_text_field, {
                                        modelValue: _ctx.addressFormData.detail,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.addressFormData.detail) = $event)),
                                        "data-cy": "address-detail-input",
                                        "hide-details": "",
                                        variant: "outlined",
                                        dense: "",
                                        placeholder: _ctx.$t(`${_ctx.lc}postcode_detail_input_label`),
                                        class: "px-4 pt-2"
                                    }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
                                ])
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_divider),
                    _createCommentVNode(" 확인 취소 "),
                    _createVNode(_component_DialogFooter, {
                        cancel: true,
                        ok: true,
                        "on-ok": _ctx.handleClickOkChangePostcode,
                        "on-cancel": _ctx.handleClickCancelChangePostcode
                    }, null, 8 /* PROPS */, ["on-ok", "on-cancel"]),
                    _createCommentVNode(" 주소 검색 다이얼로그 (다음주소) "),
                    _createVNode(_component_v_dialog, {
                        modelValue: _ctx.postcodeDialog,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.postcodeDialog) = $event)),
                        "content-class": "responsive-dialog postcode-dialog"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_DialogHeader, {
                                        title: _ctx.$t(`${_ctx.lc}search_postcode`),
                                        "on-cancel": _ctx.handleClickCancelPostcode
                                    }, null, 8 /* PROPS */, ["title", "on-cancel"]),
                                    _createElementVNode("div", _hoisted_4, null, 512 /* NEED_PATCH */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["modelValue"]));
}
